import { useLocationStore } from '@global-store/stores/location'

import BrandApiFactory from '@fond-of/brand-api'
import { ContentfulClientConsumer, type EntriesProps } from '@fond-of/content'
import SprykerApiFactory from '@fond-of/spryker-api'

const getSprykerApiUrl = () => {
  const sprykerApiUrl = import.meta.env.PUBLIC_API_URL

  if (!sprykerApiUrl) {
    throw 'You need to provide the spryker api url'
  }

  return sprykerApiUrl
}

export const sprykerApiClient = SprykerApiFactory.new(getSprykerApiUrl())

const getBrandApiUrl = () => {
  const brandApiUrl = import.meta.env.PUBLIC_BRAND_URL

  if (!brandApiUrl) {
    throw 'You need to provide the brand api url'
  }

  return brandApiUrl
}

export const brandApiClient = BrandApiFactory.new(getBrandApiUrl(), {
  headers: {
    Brand: import.meta.env.PUBLIC_BRAND,
  },
})

const contentfulClient = new ContentfulClientConsumer(
  import.meta.env.PUBLIC_CONTENTFUL_ACCESS_TOKEN,
  import.meta.env.PUBLIC_CONTENTFUL_SPACE
)

export const getContentfulApiClient = () => {
  const getEntriesById = async <T>({
    entryId,
  }: {
    entryId: string
    contentType: string
  }) => {
    const locationStore = useLocationStore()

    await contentfulClient.getEntries<T>({
      'sys.id': entryId,
      locale: locationStore.currentLocale,
    })
  }

  const getEntriesByFieldValueMatch = async <T>(
    fieldName: string,
    query: string,
    options: EntriesProps
  ) => {
    const locationStore = useLocationStore()
    const brand = import.meta.env.PUBLIC_BRAND

    return await contentfulClient.getEntries<T>({
      [`fields.${fieldName}[match]`]: query,
      ['metadata.tags.sys.id[in]']: brand,
      locale: locationStore.currentLocale,
      ...options,
    })
  }

  return {
    getEntriesById,
    getEntriesByFieldValueMatch,
  }
}
